import type { AgentV2SearchDefaults } from '@/agent-v2/store/schemas'
import type { CaselawSearchFilter, LRRSearchFilter } from '@/agent-v2/chat-form/store/schemas'

export function buildAgentV2SearchDefaultsFromAgentFilters(args: {
  caselawSearchFilter: CaselawSearchFilter | null
  includeUnpublishedCases: boolean
  lrrSearchFilter: LRRSearchFilter | null
  fileIds: string[]
  writingSampleFileId: string | null
  webSearchEnabled: boolean
}): AgentV2SearchDefaults {
  return {
    caselaw: {
      jurisdiction_codes: args.caselawSearchFilter?.jurisdiction_codes ?? [],
      date_low: args.caselawSearchFilter?.date_low ?? null,
      date_high: args.caselawSearchFilter?.date_high ?? null,
      include_unpublished_cases: args.includeUnpublishedCases,
    },
    lrr: {
      jurisdiction_codes: args.lrrSearchFilter?.jurisdiction_codes ?? [],
    },
    attached_file_ids: args.fileIds,
    web_search_enabled: args.webSearchEnabled,
    writing_sample_file_id: args.writingSampleFileId,
  }
}
